(function() {
 // CC injects `min-height:65px!important` on .product-form__cart-submit via a <style> tag.
 // Stylesheet !important can only be beaten by inline !important (highest cascade rank).
 // Watch for the button appearing in the DOM (quick view injects it dynamically) and
 // apply inline !important styles to override CC's min-height.
 new MutationObserver(function(mutations) {
   mutations.forEach(function(m) {
     m.addedNodes.forEach(function(node) {
       if (node.nodeType !== 1) return;
       var btns = node.querySelectorAll
         ? node.querySelectorAll('.product-form__cart-submit')
         : [];
       Array.prototype.forEach.call(btns, function(btn) {
         btn.style.setProperty('min-height', '44px', 'important');
         btn.style.setProperty('padding-top', '12px', 'important');
         btn.style.setProperty('padding-bottom', '12px', 'important');
       });
     });
   });
 }).observe(document.body, { childList: true, subtree: true });


 // Exposed to capture-phase handler once AJAX is ready.
 var _ajaxNavigate = null;
 // Queued navigation if user clicks before jQuery/AJAX is ready.
 var _pendingNav   = null;
 // Virtual URL — tracks the path/search of the currently displayed AJAX content.
 // window.location never updates (no pushState) so we maintain our own record.
 var _virtualPath   = window.location.pathname;
 var _virtualSearch = window.location.search;


 // ── Hard block on #FilterTags / #SortBy change events ────────────────────
 // CC's Zepto and Debut's jQuery both listen on these elements and navigate
 // via document.location.href when a change event fires.
 // A document-level CAPTURE handler fires before ANY element-level handler
 // (Zepto or jQuery) regardless of script execution order.
 // We own navigation now — nothing on #FilterTags/#SortBy should ever navigate.
 document.addEventListener('change', function(e) {
   var id = e.target && e.target.id;
   if (id === 'FilterTags' || id === 'SortBy') {
     e.stopImmediatePropagation();
     e.stopPropagation();
     return;
   }
   // CC's document-level Zepto delegation catches change on ANY select whose value
   // looks like a URL path (starts with '/') and navigates via location.href.
   // Block it here in capture phase and handle navigation ourselves.
   if (id === 'native-filter-sel') {
     e.stopImmediatePropagation();
     e.stopPropagation();
     var val = e.target.value;
     if (val) {
       var s = new URLSearchParams(_virtualSearch).get('sort_by') || null;
       var url = s ? val + '?sort_by=' + s : val;
       if (_ajaxNavigate) { _ajaxNavigate(url); }
       else { _pendingNav = url; }
     }
     return;
   }
 }, true);


 function waitForJQuery(callback) {
   if (window.jQuery) callback(window.jQuery);
   else setTimeout(function() { waitForJQuery(callback); }, 100);
 }


 // ── Capture phase ─────────────────────────────────────────────────────────
 // Runs TOP-DOWN before any bubble-phase handler (including CC's jQuery delegation).
 // e.stopPropagation() here means CC never sees the click.
 document.addEventListener('click', function(e) {
   var target = e.target;


   // Sort button toggle
   if (target.closest && target.closest('#native-fs-sticky .cc-fs-sort')) {
     e.stopPropagation();
     document.body.classList.toggle('cc-fs-sort-open');
     document.body.classList.remove('cc-fs-filter-open');
     return;
   }


   // Filter button toggle
   if (target.closest && target.closest('#native-fs-sticky .cc-fs-filter')) {
     e.stopPropagation();
     document.body.classList.toggle('cc-fs-filter-open');
     document.body.classList.remove('cc-fs-sort-open');
     return;
   }


   // Sort item — capture phase blocks CC's bubble-phase handler on .cc-fs-sort-popup
   var sortItem = target.closest && target.closest('.cc-fs-sort-items .cc-fs-sort-list');
   if (sortItem) {
     e.stopImmediatePropagation();
     document.querySelectorAll('.cc-fs-sort-list').forEach(function(el) { el.classList.remove('cc-fs-sort-active'); });
     sortItem.classList.add('cc-fs-sort-active');
     document.body.classList.remove('cc-fs-sort-open');
     var sortVal = sortItem.getAttribute('data-id');
     var sortUrl = _virtualPath + '?sort_by=' + sortVal;
     if (_ajaxNavigate) {
       _ajaxNavigate(sortUrl);
     } else {
       _pendingNav = sortUrl;
     }
     return;
   }


   // Filter item — capture phase blocks CC's bubble-phase handler on .cc-fs-filter-popup
   var filterItem = target.closest && target.closest('.cc-fs-filter-items .cc-fs-filter-list');
   if (filterItem) {
     e.stopImmediatePropagation();
     document.querySelectorAll('.cc-fs-filter-list').forEach(function(el) { el.classList.remove('cc-fs-filter-active'); });
     filterItem.classList.add('cc-fs-filter-active');
     document.body.classList.remove('cc-fs-filter-open');
     var filterPath = filterItem.getAttribute('data-id');
     if (filterPath) {
       var currentSort = new URLSearchParams(_virtualSearch).get('sort_by') || null;
       var filterUrl = currentSort ? filterPath + '?sort_by=' + currentSort : filterPath;
       if (_ajaxNavigate) {
         _ajaxNavigate(filterUrl);
       } else {
         _pendingNav = filterUrl;
       }
     }
     return;
   }


   // Close sort popup
   if (target.closest && target.closest('.cc-fs-sort-close')) {
     e.stopPropagation();
     document.body.classList.remove('cc-fs-sort-open');
     return;
   }


   // Close filter popup
   if (target.closest && target.closest('.cc-fs-filter-close')) {
     e.stopPropagation();
     document.body.classList.remove('cc-fs-filter-open');
     return;
   }


   // Backdrop tap — dismiss all (only our native backdrop, not CC's quick view backdrop)
   if (target.closest && target.closest('.cc-sf-backdrop[data-native]')) {
     e.stopPropagation();
     document.body.classList.remove('cc-fs-sort-open', 'cc-fs-filter-open');
     return;
   }
 }, true); // true = capture phase


 // ── jQuery-dependent logic ────────────────────────────────────────────────
 waitForJQuery(function($) {


   function waitForElement(selector, callback) {
     if ($(selector).length) callback();
     else setTimeout(function() { waitForElement(selector, callback); }, 200);
   }


   // Move fixed overlays to <body> so position:fixed is viewport-relative.
   // Filter to elements NOT already in body — avoids accidentally grabbing and
   // stamping data-native on CC's own backdrop if CC initialised before us.
   $(function() {
     var $overlays = $('.cc-fs-sort-popup, .cc-fs-filter-popup, .cc-sf-backdrop').filter(function() {
       return this.parentElement !== document.body;
     });
     $overlays.attr('data-native', 'true');
     $('body').append($overlays.detach());
   });


   // Kill CC's injected mobile sticky sections
   function killCCMobileElements() {
     document.querySelectorAll('.cc-fs-sticky-section:not(#native-fs-sticky)').forEach(function(el) { el.remove(); });
   }
   killCCMobileElements();


   var bodyObserver = new MutationObserver(function(mutations) {
     mutations.forEach(function(m) {
       m.addedNodes.forEach(function(node) {
         if (node.nodeType !== 1) return;
         if (node.classList.contains('cc-fs-sticky-section') && node.id !== 'native-fs-sticky') {
           node.remove();
         }
         // Do NOT remove .cc-sf-backdrop — CC reuses it for the quick view
         // popup's form/cart section. Removing it kills the quick view on mobile.
         if (
           (node.classList.contains('cc-fs-sort-popup') ||
            node.classList.contains('cc-fs-filter-popup')) &&
           !node.hasAttribute('data-native')
         ) {
           node.remove();
         }
       });
     });
   });
   bodyObserver.observe(document.body, { childList: true });


   // ── AJAX navigation ───────────────────────────────────────────────────────


   function showLoading() {
     var grid = document.querySelector('#Collection ul.grid');
     if (grid) grid.classList.add('cc-ajax-loading');
   }


   function hideLoading() {
     var grid = document.querySelector('#Collection ul.grid');
     if (grid) grid.classList.remove('cc-ajax-loading');
   }


   function buildFilterUrl(filterPath) {
     var currentSort = new URLSearchParams(_virtualSearch).get('sort_by') || null;
     return currentSort ? filterPath + '?sort_by=' + currentSort : filterPath;
   }


   function buildSortUrl(sortVal) {
     return _virtualPath + '?sort_by=' + sortVal;
   }


   function syncActiveStates(url) {
     var urlParts   = url.split('?');
     var filterPath = urlParts[0];
     var activeSort = new URLSearchParams(urlParts[1] || '').get('sort_by') || $('#native-sort-sel').val() || '';


     // Keep virtual URL in sync so subsequent sort/filter builds correct URLs.
     _virtualPath   = filterPath;
     _virtualSearch = urlParts[1] ? '?' + urlParts[1] : '';


     // Update our visible selects only.
     // #FilterTags / #SortBy are intentionally NOT updated here — CC polls their
     // value against window.location and would navigate if they diverged.
     $('#native-filter-sel').val(filterPath);
     $('#native-sort-sel').val(activeSort);


     // Update mobile popup active classes
     $('.cc-fs-filter-list').removeClass('cc-fs-filter-active');
     $('.cc-fs-filter-list[data-id="' + filterPath + '"]').addClass('cc-fs-filter-active');
     $('.cc-fs-sort-list').removeClass('cc-fs-sort-active');
     $('.cc-fs-sort-list[data-id="' + activeSort + '"]').addClass('cc-fs-sort-active');
   }


   function ajaxNavigate(url) {
     showLoading();


     fetch(url)
       .then(function(r) {
         if (!r.ok) throw new Error('Network error');
         return r.text();
       })
       .then(function(html) {
         try {
           var doc = new DOMParser().parseFromString(html, 'text/html');


           // Replace product grid
           var newGrid     = doc.querySelector('#Collection ul.grid');
           var currentGrid = document.querySelector('#Collection ul.grid');
           if (newGrid && currentGrid) {
             currentGrid.className = newGrid.className;
             currentGrid.innerHTML = newGrid.innerHTML;
           }


           // Replace pagination (sits outside #Collection in Debut's DOM structure)
           var newPagination     = doc.querySelector('ul.list--inline.pagination');
           var currentPagination = document.querySelector('ul.list--inline.pagination');
           if (newPagination && currentPagination) {
             currentPagination.outerHTML = newPagination.outerHTML;
           } else if (newPagination && !currentPagination) {
             var collectionEl = document.getElementById('Collection');
             if (collectionEl) {
               var sibling = collectionEl.nextSibling;
               collectionEl.parentNode.insertBefore(
                 document.adoptNode(newPagination), sibling || null
               );
             }
           } else if (!newPagination && currentPagination) {
             currentPagination.remove();
           }


           syncActiveStates(url);
         } catch (domErr) {
           console.error('[cc-ajax] DOM update error:', domErr);
         }


         hideLoading();


         // Scroll to top of collection
         var top = document.getElementById('Collection');
         if (top) window.scrollTo({ top: top.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
       })
       .catch(function(netErr) {
         // Only navigate on a real network / HTTP error — never on a DOM exception
         // (DOM exceptions are caught above and logged without navigating).
         console.error('[cc-ajax] Fetch error:', netErr);
         hideLoading();
         if (netErr && netErr.message && netErr.message.indexOf('Network') === 0) {
           window.location.href = url;
         }
       });
   }


   // Expose to capture-phase handler; drain any click that arrived before jQuery was ready
   _ajaxNavigate = ajaxNavigate;
   if (_pendingNav) { ajaxNavigate(_pendingNav); _pendingNav = null; }


   // ── Single waiter — mirrors original CC's waitForElement('.filters-toolbar') ──
   waitForElement('.filters-toolbar', function() {
     var $filterSel = $('.filters-toolbar #FilterTags');
     var $sortSel   = $('.filters-toolbar #SortBy');
     var $ccFilter  = $('#native-filter-sel');
     var $ccSort    = $('#native-sort-sel');


     // Remove Debut's change→location.href handlers on #FilterTags and #SortBy.
     // CC calls .trigger('change') on these after popup clicks (1s delay) which
     // would cause a full page reload even while our AJAX is running.
     $filterSel.off('change');
     $sortSel.off('change');


     // Desktop sidebar — clone options from Debut's hidden selects
     if ($filterSel.length) $ccFilter.html($filterSel.html()).val($filterSel.val());
     if ($sortSel.length)   $ccSort.html($sortSel.html()).val($sortSel.val());


     // Bind AJAX handlers to the desktop selects.
     // Re-queries by ID so the clone-strip below gets fresh elements.
     function bindDesktopHandlers() {
       // #native-filter-sel change is owned by the document capture handler above —
       // the event is stopped before reaching this element, so no binding needed here.
       $('#native-filter-sel').off('change');
       $('#native-sort-sel').off('change').on('change', function() {
         ajaxNavigate(buildSortUrl($(this).val()));
       });
     }
     bindDesktopHandlers();


     // Desktop dropdown — a native multi-option <select>'s open state is a
     // browser-drawn overlay that ignores page CSS and can span/obscure the
     // header. Block that native popup (mousedown preventDefault, standard
     // cross-browser trick) and reuse the same styled dropdown list + AJAX
     // logic already built for the mobile filter/sort popups instead.
     function openDesktopDropdown(which, anchorEl) {
       var openClass  = which === 'sort' ? 'cc-fs-sort-open' : 'cc-fs-filter-open';
       var otherClass = which === 'sort' ? 'cc-fs-filter-open' : 'cc-fs-sort-open';
       var isOpen = document.body.classList.contains(openClass);
       document.body.classList.remove('cc-fs-sort-open', 'cc-fs-filter-open');
       if (isOpen) return;

       // These popups live at the end of <body> (moved there so their mobile
       // position:fixed is viewport-relative), so on desktop they need their
       // position computed from the trigger <select> each time they open
       // rather than a fixed in-flow CSS anchor.
       var popup = document.querySelector(which === 'sort' ? '.cc-fs-sort-popup' : '.cc-fs-filter-popup');
       if (popup && anchorEl) {
         var rect = anchorEl.getBoundingClientRect();
         popup.style.top  = (rect.bottom + window.scrollY + 6) + 'px';
         popup.style.left = (rect.left + window.scrollX) + 'px';
         popup.style.width = rect.width + 'px';
       }
       document.body.classList.add(openClass);
       document.body.classList.remove(otherClass);
     }
     $('#native-filter-sel').on('mousedown', function(e) {
       e.preventDefault();
       this.blur();
       openDesktopDropdown('filter', this);
     });
     $('#native-sort-sel').on('mousedown', function(e) {
       e.preventDefault();
       this.blur();
       openDesktopDropdown('sort', this);
     });


     // Re-strip Debut handlers after a short delay (guards against any re-bind).
     setTimeout(function() {
       $filterSel.off('change');
       $sortSel.off('change');
     }, 500);


     function killCCSidebars() {
       document.querySelectorAll('.cc-sfs-section:not(#native-collection-sidebar)').forEach(function(el) {
         el.remove();
       });
     }
     killCCSidebars();


     var collectionObserver = new MutationObserver(function(mutations) {
       mutations.forEach(function(m) {
         m.addedNodes.forEach(function(node) {
           if (node.nodeType === 1 && node.classList.contains('cc-sfs-section') && node.id !== 'native-collection-sidebar') {
             node.remove();
           }
         });
       });
     });
     var collection = document.getElementById('Collection');
     if (collection) collectionObserver.observe(collection, { childList: true });


     // ── Mobile popup population ─────────────────────────────────────────
     setTimeout(function() {
       var $sortItems   = $('.cc-fs-sort-items');
       var $filterItems = $('.cc-fs-filter-items');


       if ($sortSel.length && $sortItems.length) {
         $sortItems.empty();
         var activeSort = new URLSearchParams(window.location.search).get('sort_by') || 'best-selling';
         $sortSel.find('option').each(function() {
           var val = $(this).val(), text = $(this).text();
           $sortItems.append(
             '<li><a class="cc-fs-sort-list' + (val === activeSort ? ' cc-fs-sort-active' : '') + '" data-id="' + val + '">' + text + '</a></li>'
           );
         });
       }


       if ($filterSel.length && $filterItems.length) {
         $filterItems.empty();
         var activeFilter = $filterSel.val();
         $filterSel.find('option').each(function() {
           var val  = $(this).val();
           var text = $.trim($(this).text());
           var isActive = (val === activeFilter) && val !== '/collections/all';
           $filterItems.append(
             '<li><a class="cc-fs-filter-list' + (isActive ? ' cc-fs-filter-active' : '') + '" data-id="' + val + '">' +
               '<span class="cc-filter-radio"></span><span class="cc-filter-text">' + text + '</span>' +
             '</a></li>'
           );
         });
       }
     }, 500);


     // NOTE: Mobile item clicks are handled in the capture-phase listener above.
     // They are NOT repeated here as jQuery delegation to avoid CC's bubble-phase
     // handler on .cc-fs-filter-popup firing first and triggering location.href.
   });


   // Chat widget — push above sticky bar when minimised.
   // Also detect CC quick view open state so we can hide the sticky bar
   // (CC shrinks its popup to avoid its own bar; since we replaced CC's bar,
   // CC makes the popup full-height and our bar covers the cart section).
   setInterval(function() {
     var $chat = $('#ShopifyChat');
     if ($chat.length) {
       $('body').toggleClass('cc-chat-adjust', $chat.css('height') === '100%');
     }
     // CC keeps .cc-quick-view in DOM even when closed — check visibility, not just presence
     var qvEl = document.querySelector('.cc-quick-view');
     var qvOpen = !!(qvEl && qvEl.offsetHeight > 0);
     document.body.classList.toggle('cc-qv-open', qvOpen);
     // Real visible height — window.innerHeight excludes mobile browser chrome
     // (100vh on Safari/Chrome includes the toolbar, pushing the cart off-screen)
     document.documentElement.style.setProperty('--real-vh', window.innerHeight + 'px');
   }, 200);


 });
})();



